import { render, staticRenderFns } from "./comFooter.vue?vue&type=template&id=4f2e703c&scoped=true&"
import script from "./comFooter.vue?vue&type=script&lang=js&"
export * from "./comFooter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./comFooter.vue?vue&type=style&index=0&id=4f2e703c&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f2e703c",
  "1db3bd57"
  
)

export default component.exports